import {CONSTANTS} from "../../constants/constants";
import {lazy} from "react";
import {withAuth} from "../../hocs/withAuth";

const Profile = lazy(() => import("../../pages/Profile/Profile"));
const BookingDetails = lazy(() => import("../../pages/booking/BookingDetails/BookingDetails"));
const BookingPaymentResult = lazy(() => import("../../pages/booking/BookingPaymentResult/BookingPaymentResult"));

const {PROFILE, BOOKING_DETAILS} = CONSTANTS.ROUTES;

export const authRoutes = [
  {
    path: PROFILE.path + "/*",
    component: withAuth(Profile),
  },
  {
    path: BOOKING_DETAILS.path,
    component: withAuth(BookingDetails),
  },
  {
    path: "payment/result",
    component: withAuth(BookingPaymentResult),
  },
];